var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.93,199.44c-6.98,1.98-15.18-1.59-21.23-6.36C53.73,169.71,18.31,86.72,18.76,24.39c.26-7.04.35-11.07,2.67-13.67,1.86-1.56,4.72.95,8.5,6.37,2.75,3.91,5.98,9.31,9.58,15,14.52,22.72,32.72,41.74,56.55,44.61,20.71,1.93,38.46-11.54,51.62-26.62,7.78-8.63,15.06-21.41,21.49-30.46,13.43-19.33,12.66,5.97,12.23,16.72-3.41,59.03-32.12,119.59-58.96,152.11-4.32,4.92-9.51,9.46-15.42,10.99l-.09.02Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.99,
    cy: 33.82,
    r: 33.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUser);
export default __webpack_public_path__ + "static/media/menu-user.69fc76fb13cf289d24ec3090270c13e5.svg";
export { ForwardRef as ReactComponent };